


























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Axios from 'axios';
import * as signalR from '@microsoft/signalr';
import { formatDateToRussian, getDateUTC } from '../helpers/date-helpers';

@Component({})
export default class ImportFileComponent extends Vue {
	@Prop({ required: true, type: String }) public hubUrl: string;
	@Prop({ required: false, type: String }) public title?: string;
	@Prop({ required: false, type: Boolean }) public calendar?: boolean;
	@Prop({ required: false, type: Boolean }) public operator?: boolean;

	public hub: signalR.HubConnection | null = null;

	public dateDialog = false;
	public date = new Date().toISOString().substr(0, 10);
	public valid = false;
	public isUploading = false;
	public validated = false;
	public errors: string | null = null;

	public operatorId: number = 0;
	public operators = [];
	public file: string | Blob | null = null;

	public currentAction = 'Обработка файла';
	public progress = 0;
	public cacheKey = '';
	public rules = {
		selectionRules: [
			(v: number) => !(this.operator && v === 0) || 'Обязательное поле',
		],
	};
	public created() {
		Axios.get('/api/operators').then((r) => this.operators = r.data);
		this.hub = new signalR.HubConnectionBuilder()
			.withUrl(`/hubs/${this.hubUrl}`, { accessTokenFactory: () => this.$store.getters['oidc/oidcAccessToken'] })
			.build();
		this.hub.start();
		this.initHub();
	}

	private upload() {
		this.isUploading = true;
		const fd = new FormData();
		fd.append('file', this.file!);
		fd.append('hubConnectionId', this.hub?.connectionId!);
		this.errors = null;
		Axios.post('/api/import/file/', fd)
			.then((r) => {
				this.cacheKey = r.data;
				this.hub?.send('ValidateImport', this.cacheKey).then(() => {
					this.currentAction = 'Проверка файла';
				});
			})
			.catch((r) => this.errors = r.response.data)
			.finally(() => {
				this.progress = 0;
				this.isUploading = false;
			});
	}

	private save() {
		if ((this.$refs.importFile as any).validate()) {
			this.isUploading = true;
			let request: Promise<any> | undefined;
			if (this.calendar && this.operator) {
				request = this.hub?.send('SaveImport', this.cacheKey, this.getDateTime.toJSON(), this.operatorId);
			} else if (this.calendar) {
				request = this.hub?.send('SaveImport', this.cacheKey, this.getDateTime.toJSON());
			} else if (this.operator) {
				request = this.hub?.send('SaveImport', this.cacheKey, this.operatorId);
			} else {
				request = this.hub?.send('SaveImport', this.cacheKey);
			}
			request?.then(() => {
				this.currentAction = 'Запись в БД';
				this.progress = 0;
			}).catch((r) => this.errors = r);
		}
	}

	private get computedDateFormatted() {
		return formatDateToRussian(this.date);
	}

	private get getDateTime(): Date {
		return getDateUTC(this.date);
	}

	private get cardTitle() {
		if (this.title) {
			return this.title;
		} else {
			return `Импорт ${this.hubUrl}`;
		}
	}

	private initHub() {
		this.hub?.on('Errors', ((e) => {
			if (this.errors) {
				this.errors = this.errors.concat(e);
			} else {
				this.errors = e;
			}
		}));
		this.hub?.on('Progress', ((p) => {
			if (p === 200) {
				this.isUploading = false;
				this.validated = true;
				this.progress = 100;
			} else {
				this.progress = p;
			}
		}));
	}
}
